import React, { FunctionComponent } from 'react'
import cn from 'classnames'

import styles from './Caculator.module.scss'
import { ButtonLink } from '@/components/ButtonLink'

type CalculatorProps = {
  className?: string
}
export const Calculator: FunctionComponent<CalculatorProps> = ({
  className,
}) => {
  return (
    <div className={cn(className, styles.container)}>
      <h3 className={styles.title}>
        Рассчитайте стоимость регистрации товарного знака
      </h3>
      <div className={styles.description}>
        Всего несколько шагов до регистрации вашего товарного знака
      </div>
      <ButtonLink href="/calculator" className={styles.button}>
        Рассчитать стоимость
      </ButtonLink>
    </div>
  )
}
